import styled, { keyframes } from "styled-components";
import { MediaQueries } from "ratel-ui";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const scaleIn = keyframes`
  from { opacity: 0; transform: scale(0.96); }
  to { opacity: 1; transform: scale(1); }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.65);
  animation: ${fadeIn} 0.2s ease-out;

  ${MediaQueries.mobile`
    padding: 16px;
  `}
`;

export const Card = styled.div`
  position: relative;
  width: 100%;
  max-width: 480px;
  background: #0a0a0a;
  border: 1.5px solid rgba(247, 213, 24, 0.5);
  border-radius: 24px;
  box-shadow: 0px 16px 48px rgba(0, 0, 0, 0.25);
  padding: 40px 40px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  animation: ${scaleIn} 0.2s ease-out;

  ${MediaQueries.mobile`
    padding: 28px 24px 24px;
    gap: 16px;
    border-radius: 20px;
  `}
`;

export const IconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  background: #fef9db;
  border-radius: 999px;
  font-size: 34px;
  line-height: 1;
`;

export const Title = styled.h2`
  margin: 0;
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 30px;
  line-height: 1.1;
  color: #ffffff;
  text-align: center;

  ${MediaQueries.mobile`
    font-size: 24px;
  `}
`;

export const Description = styled.p`
  margin: 0;
  font-family: "Nunito", sans-serif;
  font-weight: 700;
  font-size: 15px;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.7);
  text-align: center;

  ${MediaQueries.mobile`
    font-size: 14px;
  `}
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding-top: 8px;
  width: 100%;
`;

export const ConfirmButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 18px 24px;
  background: #0e8a3e;
  border: none;
  border-radius: 999px;
  color: #ffffff;
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 16px;
  letter-spacing: 1px;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;

  &:hover {
    background: #0c7434;
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

export const CancelButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 14px 24px;
  background: transparent;
  border: none;
  border-radius: 999px;
  color: rgba(255, 255, 255, 0.6);
  font-family: "Nunito", sans-serif;
  font-weight: 700;
  font-size: 15px;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: rgba(255, 255, 255, 0.9);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
